"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CheckCircle, Zap, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useEffect, useRef, useState } from "react";
export default function HowItWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const lineRef = useRef<HTMLDivElement>(null);
  const [lineWidth, setLineWidth] = useState(0);
  useEffect(() => {
    if (isVisible && lineRef.current) {
      const timer = setTimeout(() => {
        setLineWidth(100);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  const steps = [{
    number: "01",
    icon: CheckCircle,
    title: "Sign Up & Get Protected",
    description: "Contact us and agree a plan to enjoy instant coverage from HMRC enquiries with our market-leading tax fee protection insurance."
  }, {
    number: "02",
    icon: Zap,
    title: "Access Expert Support",
    description: "Get immediate access to our dedicated tax advice hotline, marketing resources, and specialist consultancy support whenever you need it."
  }, {
    number: "03",
    icon: TrendingUp,
    title: "Grow Your Practice",
    description: "Leverage our tailored marketing materials and expert guidance to attract new clients, retain existing ones, and grow your accountancy practice."
  }];
  return;
}